(function() {
    "use strict";

    // IMPORTANT:
    // It turns out we cannot directly bind using remarksCollection | filter:{prop: Value} on remarks
    // As a work-around we also pass the filter and filter locally (in the template)
    // If we do not do this, angular will enter an infinite digest cycle (it is detected and stopped after 10 nested digest calls)
    angular.module("app").component("screeningRemarksTable", {
        templateUrl: "@/screening/screeningRemarksTable.component.html",
        bindings: {
            remarks: "=",
            filterBy: "="
        },
        controller: ScreeningRemarksTableController
    });

    ScreeningRemarksTableController.$inject = ["$rootScope",];
    function ScreeningRemarksTableController($rootScope) {
        const $ctrl = this;

        $ctrl.codePartners = $rootScope.codePartners;
    }
})();